import React, { useEffect, useState, useRef } from "react";
import "./HomePage.css";

const slides = [
  {
    bg: "https://getwallpapers.com/wallpaper/full/3/c/7/943514-dance-background-images-1920x1080-for-macbook.jpg",
  },
  {
   bg: "https://res.cloudinary.com/dk50cmtps/image/upload/v1760095630/vecteezy_ai-generated-hip-hop-dancing-class-advertisment-background_37246330_dzxvpz.jpg",
  },
  {
    bg: "https://res.cloudinary.com/dk50cmtps/image/upload/v1760441078/murugan_ed1xkh.png",
  },
];

const HomePage = () => {
  const [current, setCurrent] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const progressRef = useRef(null);
  const autoPlayRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
  }, [current]);

  const startAutoPlay = () => {
    stopAutoPlay();
    autoPlayRef.current = setInterval(() => {
      nextSlide();
    }, 5000);

    if (progressRef.current) {
      progressRef.current.style.transition = "none";
      progressRef.current.style.transform = "scaleX(0)";
      setTimeout(() => {
        progressRef.current.style.transition = "transform 5s linear";
        progressRef.current.style.transform = "scaleX(1)";
      }, 50);
    }
  };

  const stopAutoPlay = () => {
    if (autoPlayRef.current) {
      clearInterval(autoPlayRef.current);
      autoPlayRef.current = null;
    }
  };

  const goToSlide = (index) => setCurrent(index);
  const nextSlide = () => setCurrent((prev) => (prev + 1) % slides.length);

  return (
    <div className="pd_home_container">
      <div className="pd_home_slideshow">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`pd_home_slide ${
              index === current ? "active" : index < current ? "prev" : "next"
            }`}
          >
            <div
              className="pd_home_slide_background"
              style={{ backgroundImage: `url(${slide.bg})` }}
            ></div>

          </div>
        ))}
      </div>

      {/* Navigation Dots */}
      <div className="pd_home_navigation d-flex justify-content-center">
        {slides.map((_, i) => (
          <div
            key={i}
            className={`pd_home_nav_dot ${i === current ? "active" : ""}`}
            onClick={() => goToSlide(i)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
